import { EventBus } from "../EventBus";

export default {
    bind(el, binding) {
        let click = () => {
            // let src = binding;

            EventBus.$emit('showImageModal', {
                url: binding.value
            })
        };

        el.addEventListener('click', click);
    }
}